const API_URL = "https://api.perajutansahabat.id";

export default API_URL;
